import React from "react";
import style from "./stylesheets/Hint.module.scss";

const Hint = ({ hintData }) => {
    if(!hintData) return null;

    const renderHintWithLinks = (text) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.split(urlRegex).map((part, index) => {
            if (urlRegex.test(part)) {
                return <a key={index} href={part} target="_blank" rel="noopener noreferrer">{part}</a>;
            }
            return part;
        });
    };

    return (
        <div className={style.hint}>
            <h1>{hintData.title}</h1>
            <p>{renderHintWithLinks(hintData.hint)}</p>
            {
                hintData.image && (
                    <img src={hintData.image} alt="Visual clue" />
                )
            }
        </div>
    )
};

export default Hint;
